import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { LegalFrameworkPageService, LegalFrameworkPage } from './shared';
import { LegalFrameworkPageCategory } from "app/legal-framework/shared/legal-framework.model";
@Component({
  selector: 'bp-legal-framework',
  templateUrl: 'legal-framework.component.html'
})

export class LegalFrameworkComponent implements OnInit, OnDestroy {

  category: LegalFrameworkPageCategory;
  initSelection: number;
  routeEventSub: any;

  constructor(
    private legalFrameworkPageService: LegalFrameworkPageService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.getCategory();
    this.routeEventSub = this.router.events
      .subscribe(event => {
        if (event instanceof NavigationEnd) {
          // console.log('snapsot rute', this.route.snapshot)
          if (!this.route.snapshot.firstChild || !this.route.snapshot.firstChild.params['id']) {
            this.initSelection = this.category && this.category.infoPages && this.category.infoPages.length && this.category.infoPages[0].id;
            if (this.initSelection) {
              this.router.navigateByUrl(`/legal-framework/${this.initSelection}`);
            }
          }
        }
      });
  }

  ngOnDestroy(): void {
    if (this.routeEventSub != null) {
      this.routeEventSub.unsubscribe();
    }
  }

  getCategory() {
    this.legalFrameworkPageService.getCategory()
      .subscribe(category => {
        this.category = category;

        if (!this.route.snapshot.firstChild || !this.route.snapshot.firstChild.params['id']) {
          this.initSelection = this.category && this.category.infoPages && this.category.infoPages.length && this.category.infoPages[0].id;
          if (this.initSelection) {
            this.router.navigateByUrl(`/legal-framework/${this.initSelection}`);
          }
        }
      });
  }
}




// WEBPACK FOOTER //
// ./src/app/legal-framework/legal-framework.component.ts